import { render, staticRenderFns } from "./CustomAuth.vue?vue&type=template&id=3b75195f"
import script from "./CustomAuth.vue?vue&type=script&lang=js"
export * from "./CustomAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports